import moment from "moment-timezone";

const hazards = {
  // From https://www.weather.gov/help-map
  "Tsunami Warning": {
    hex: "#FD6347",
    priority: 1
  },
  "Tornado Warning": {
    hex: "#FF0000",
    priority: 2
  },
  "Extreme Wind Warning": {
    hex: "#FF8C00",
    priority: 3
  },
  "Severe Thunderstorm Warning": {
    hex: "#FFA500",
    priority: 4
  },
  "Flash Flood Warning": {
    hex: "#8B0000",
    priority: 5
  },
  "Flash Flood Statement": {
    hex: "#8B0000",
    priority: 6
  },
  "Severe Weather Statement": {
    hex: "#00FFFF",
    priority: 7
  },
  "Shelter In Place Warning": {
    hex: "#FA8072",
    priority: 8
  },
  "Evacuation - Immediate": {
    hex: "#7FFF00",
    priority: 9
  },
  "Civil Danger Warning": {
    hex: "#FFB6C1",
    priority: 10
  },
  "Nuclear Power Plant Warning": {
    hex: "#4B0082",
    priority: 11
  },
  "Radiological Hazard Warning": {
    hex: "#4B0082",
    priority: 12
  },
  "Hazardous Materials Warning": {
    hex: "#4B0082",
    priority: 13
  },
  "Fire Warning": {
    hex: "#A0522D",
    priority: 14
  },
  "Civil Emergency Message": {
    hex: "#FFB6C1",
    priority: 15
  },
  "Law Enforcement Warning": {
    hex: "#C0C0C0",
    priority: 16
  },
  "Storm Surge Warning": {
    hex: "#B524F7",
    priority: 17
  },
  "Hurricane Force Wind Warning": {
    hex: "#CD5C5C",
    priority: 18
  },
  "Hurricane Warning": {
    hex: "#DC143C",
    priority: 19
  },
  "Typhoon Warning": {
    hex: "#DC143C",
    priority: 20
  },
  "Special Marine Warning": {
    hex: "#FFA500",
    priority: 21
  },
  "Blizzard Warning": {
    hex: "#FF4500",
    priority: 22
  },
  "Snow Squall Warning": {
    hex: "#C71585",
    priority: 23
  },
  "Ice Storm Warning": {
    hex: "#8B008B",
    priority: 24
  },
  "Winter Storm Warning": {
    hex: "#FF69B4",
    priority: 25
  },
  "High Wind Warning": {
    hex: "#DAA520",
    priority: 26
  },
  "Tropical Storm Warning": {
    hex: "#B22222",
    priority: 27
  },
  "Storm Warning": {
    hex: "#9400D3",
    priority: 28
  },
  "Tsunami Advisory": {
    hex: "#D2691E",
    priority: 29
  },
  "Tsunami Watch": {
    hex: "#FF00FF",
    priority: 30
  },
  "Avalanche Warning": {
    hex: "#1E90FF",
    priority: 31
  },
  "Earthquake Warning": {
    hex: "#8B4513",
    priority: 32
  },
  "Volcano Warning": {
    hex: "#2F4F4F",
    priority: 33
  },
  "Ashfall Warning": {
    hex: "#A9A9A9",
    priority: 34
  },
  "Coastal Flood Warning": {
    hex: "#228B22",
    priority: 35
  },
  "Lakeshore Flood Warning": {
    hex: "#228B22",
    priority: 36
  },
  "Flood Warning": {
    hex: "#00FF00",
    priority: 37
  },
  "High Surf Warning": {
    hex: "#228B22",
    priority: 38
  },
  "Dust Storm Warning": {
    hex: "#FFE4C4",
    priority: 39
  },
  "Blowing Dust Warning": {
    hex: "#FFE4C4",
    priority: 40
  },
  "Lake Effect Snow Warning": {
    hex: "#008B8B",
    priority: 41
  },
  "Excessive Heat Warning": {
    hex: "#C71585",
    priority: 42
  },
  "Tornado Watch": {
    hex: "#FFFF00",
    priority: 43
  },
  "Severe Thunderstorm Watch": {
    hex: "#DB7093",
    priority: 44
  },
  "Flash Flood Watch": {
    hex: "#2E8B57",
    priority: 45
  },
  "Gale Warning": {
    hex: "#DDA0DD",
    priority: 46
  },
  "Flood Statement": {
    hex: "#00FF00",
    priority: 47
  },
  "Wind Chill Warning": {
    hex: "#B0C4DE",
    priority: 48
  },
  "Extreme Cold Warning": {
    hex: "#0000FF",
    priority: 49
  },
  "Hard Freeze Warning": {
    hex: "#9400D3",
    priority: 50
  },
  "Freeze Warning": {
    hex: "#483D8B",
    priority: 51
  },
  "Red Flag Warning": {
    hex: "#FF1493",
    priority: 52
  },
  "Storm Surge Watch": {
    hex: "#DB7FF7",
    priority: 53
  },
  "Hurricane Watch": {
    hex: "#FF00FF",
    priority: 54
  },
  "Hurricane Force Wind Watch": {
    hex: "#9932CC",
    priority: 55
  },
  "Typhoon Watch": {
    hex: "#FF00FF",
    priority: 56
  },
  "Tropical Storm Watch": {
    hex: "#F08080",
    priority: 57
  },
  "Storm Watch": {
    hex: "#FFE4B5",
    priority: 58
  },
  "Hurricane Local Statement": {
    hex: "#FFE4B5",
    priority: 59
  },
  "Typhoon Local Statement": {
    hex: "#FFE4B5",
    priority: 60
  },
  "Tropical Storm Local Statement": {
    hex: "#FFE4B5",
    priority: 61
  },
  "Tropical Cyclone Statement": {
    hex: "#FFE4B5",
    priority: 61
  },
  "Tropical Depression Local Statement": {
    hex: "#FFE4B5",
    priority: 62
  },
  "Avalanche Advisory": {
    hex: "#CD853F",
    priority: 63
  },
  "Freezing Rain Advisory": {
    hex: "#DA70D6",
    priority: 64
  },
  "Winter Weather Advisory": {
    hex: "#7B68EE",
    priority: 65
  },
  "Lake Effect Snow Advisory": {
    hex: "#48D1CC",
    priority: 66
  },
  "Wind Chill Advisory": {
    hex: "#AFEEEE",
    priority: 67
  },
  "Heat Advisory": {
    hex: "#FF7F50",
    priority: 68
  },
  "Urban And Small Stream Flood Advisory": {
    hex: "#00FF7F",
    priority: 69
  },
  "Small Stream Flood Advisory": {
    hex: "#00FF7F",
    priority: 70
  },
  "Arroyo And Small Stream Flood Advisory": {
    hex: "#00FF7F",
    priority: 71
  },
  "Flood Advisory": {
    hex: "#00FF7F",
    priority: 72
  },
  "Hydrologic Advisory": {
    hex: "#00FF7F",
    priority: 73
  },
  "Lakeshore Flood Advisory": {
    hex: "#7CFC00",
    priority: 74
  },
  "Coastal Flood Advisory": {
    hex: "#7CFC00",
    priority: 75
  },
  "High Surf Advisory": {
    hex: "#BA55D3",
    priority: 76
  },
  "Heavy Freezing Spray Warning": {
    hex: "#00BFFF",
    priority: 77
  },
  "Dense Fog Advisory": {
    hex: "#708090",
    priority: 78
  },
  "Dense Smoke Advisory": {
    hex: "#F0E68C",
    priority: 79
  },
  "Small Craft Advisory For Hazardous Seas": {
    hex: "#D8BFD8",
    priority: 80
  },
  "Small Craft Advisory For Rough Bar": {
    hex: "#D8BFD8",
    priority: 81
  },
  "Small Craft Advisory For Winds": {
    hex: "#D8BFD8",
    priority: 82
  },
  "Small Craft Advisory": {
    hex: "#D8BFD8",
    priority: 83
  },
  "Brisk Wind Advisory": {
    hex: "#D8BFD8",
    priority: 84
  },
  "Hazardous Seas Warning": {
    hex: "#D8BFD8",
    priority: 85
  },
  "Dust Advisory": {
    hex: "#BDB76B",
    priority: 86
  },
  "Blowing Dust Advisory": {
    hex: "#BDB76B",
    priority: 87
  },
  "Lake Wind Advisory": {
    hex: "#D2B48C",
    priority: 88
  },
  "Wind Advisory": {
    hex: "#D2B48C",
    priority: 89
  },
  "Frost Advisory": {
    hex: "#6495ED",
    priority: 90
  },
  "Ashfall Advisory": {
    hex: "#696969",
    priority: 91
  },
  "Freezing Fog Advisory": {
    hex: "#008080",
    priority: 92
  },
  "Freezing Spray Advisory": {
    hex: "#00BFFF",
    priority: 93
  },
  "Low Water Advisory": {
    hex: "#A52A2A",
    priority: 94
  },
  "Local Area Emergency": {
    hex: "#C0C0C0",
    priority: 95
  },
  "Child Abduction Emergency": {
    hex: "#FFD700",
    priority: 96
  },
  "Avalanche Watch": {
    hex: "#F4A460",
    priority: 97
  },
  "Blizzard Watch": {
    hex: "#ADFF2F",
    priority: 98
  },
  "Rip Current Statement": {
    hex: "#40E0D0",
    priority: 99
  },
  "Beach Hazards Statement": {
    hex: "#40E0D0",
    priority: 100
  },
  "Gale Watch": {
    hex: "#FFC0CB",
    priority: 101
  },
  "Winter Storm Watch": {
    hex: "#4682B4",
    priority: 102
  },
  "Hazardous Seas Watch": {
    hex: "#483D8B",
    priority: 103
  },
  "Heavy Freezing Spray Watch": {
    hex: "#BC8F8F",
    priority: 104
  },
  "Coastal Flood Watch": {
    hex: "#66CDAA",
    priority: 105
  },
  "Lakeshore Flood Watch": {
    hex: "#66CDAA",
    priority: 106
  },
  "Flood Watch": {
    hex: "#2E8B57",
    priority: 107
  },
  "High Wind Watch": {
    hex: "#B8860B",
    priority: 108
  },
  "Excessive Heat Watch": {
    hex: "#800000",
    priority: 109
  },
  "Extreme Cold Watch": {
    hex: "#0000FF",
    priority: 110
  },
  "Wind Chill Watch": {
    hex: "#5F9EA0",
    priority: 111
  },
  "Lake Effect Snow Watch": {
    hex: "#87CEFA",
    priority: 112
  },
  "Hard Freeze Watch": {
    hex: "#4169E1",
    priority: 113
  },
  "Freeze Watch": {
    hex: "#00FFFF",
    priority: 114
  },
  "Fire Weather Watch": {
    hex: "#FFDEAD",
    priority: 115
  },
  "Extreme Fire Danger": {
    hex: "#E9967A",
    priority: 116
  },
  "911 Telephone Outage": {
    hex: "#C0C0C0",
    priority: 117
  },
  "Coastal Flood Statement": {
    hex: "#6B8E23",
    priority: 118
  },
  "Lakeshore Flood Statement": {
    hex: "#6B8E23",
    priority: 119
  },
  "Special Weather Statement": {
    hex: "#FFE4B5",
    priority: 120
  },
  "Marine Weather Statement": {
    hex: "#FFDAB9",
    priority: 121
  },
  "Air Quality Alert": {
    hex: "#808080",
    priority: 122
  },
  "Air Stagnation Advisory": {
    hex: "#808080",
    priority: 123
  },
  "Hazardous Weather Outlook": {
    hex: "#EEE8AA",
    priority: 124
  },
  "Hydrologic Outlook": {
    hex: "#90EE90",
    priority: 125
  },
  "Short Term Forecast": {
    hex: "#98FB98",
    priority: 126
  },
  "Administrative Message": {
    hex: "#C0C0C0",
    priority: 127
  },
  Test: {
    hex: "#F0FFFF",
    priority: 128
  }
};

const shapes_cache = {
  cache: {},
  processing: {}
};

const process_zone = async zone_url => {
  try {
    const response = await fetch(zone_url);
    const json = await response.json();
    delete shapes_cache.processing[zone_url];
    shapes_cache.cache[zone_url] = json;
    return json;
  } catch {
    delete shapes_cache.processing[zone_url];
    console.warn("Unable to load", zone_url);
    return null;
  }
};

const load_zone = async zone_url => {
  if (!shapes_cache.processing.hasOwnProperty(zone_url)) {
    const processing = {
      wait: process_zone(zone_url),
      zone: zone_url
    };
    shapes_cache.processing[zone_url] = processing;
  }
  return shapes_cache.processing[zone_url].wait;
};

const fillGeometry = alert => {
  if (alert.geometry) {
    // no need to fill
    return alert;
  }
  const missing = alert.properties.affectedZones.filter(
    z => !shapes_cache.cache.hasOwnProperty(z)
  );
  if (missing.length > 0) {
    throw Error(
      "Cannot fill alert geometry due to missing zones: " + missing.join(",")
    );
  }

  const geometries = alert.properties.affectedZones.map(
    z => shapes_cache.cache[z].geometry
  );

  const geometry = {
    type: "GeometryCollection",
    geometries: geometries
  };
  const newAlert = {...alert, geometry};
  return newAlert;
};

// Returns the object but with the given prop converted to a moment instance.
const tryMoment = (obj, prop) => {
  if (obj.hasOwnProperty(prop)) {
    try {
      obj = { ...obj, [prop]: moment.tz(obj[prop], "UTC") };
    } catch (err) {
      console.warn(`Error when converting ${prop}`, err);
    }
  }
  return obj;
};

const tryTimestamp = value => {
  if (typeof value !== "undefined") {
    try {
      return moment.tz(value, "UTC").valueOf();
    } catch (err) {
      console.warn(`Error when converting ${value} to timestamp`, err);
    }
  }
  return value;
}

const apiReformat = apiResponse => {
  return apiResponse.features
    .filter(f => f.properties.status.toLowerCase() === "actual")
    .filter(f => f.properties.event.toLowerCase() !== "hydrologic outlook") // These appear for many days and are not urgent enough for the map.
    .map(f => {
      const hazardInfo = hazards[f.properties.event];
      const returnable = { ...f, properties: { ...f.properties } };
      let props = returnable.properties;
      if (hazardInfo) {
        props.plotting = hazardInfo;
      }

      ["effective", "expires", "onset", "sent", "ends"].forEach(p => {
        props[p] = tryTimestamp(props[p]);
      });
      returnable.properties = props;
      return returnable;
    });
};
export { apiReformat };

const loadZones = async alerts => {
  // Find all zones referenced in alerts that don't have a geometry.
  const zones = [];
  alerts
    .filter(a => a.geometry === null)
    .forEach(a => {
      if (typeof a.properties.affectedZones === "object") {
        const not_cached = a.properties.affectedZones.filter(
          z => !shapes_cache.cache.hasOwnProperty(z)
        );
        zones.push(...not_cached);
      }
    });

  // This will only contain the zones that have not already been
  // received.
  const needed = Array.from(new Set(zones));

  // For each zone that's needed, add it to the waiters list.
  const waiters = needed.map(z => load_zone(z));

  // Now we wait
  for (let i = 0; i < waiters.length; i++) {
    await waiters[i];
  }

  const newAlerts = alerts.map(a => {
    try {
      return fillGeometry(a);
    } catch (err) {
      console.warn("Unable to fill geometry", err);
      return a;
    }
  });

  return newAlerts;
};
export { loadZones };

export { hazards };
